/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ErrorResponse {
  error: number;
  message: string;
  reason?: string;
}

export interface SuccessResponse {
  success: boolean;
}

export interface GridDecorator {
  id?: string;
  identifier?: string;
  name?: string;
  parent?: string;
  active?: boolean;
  userId?: string;
  default?: boolean;
  system?: boolean;
  plugins?: {
    name?: string;
    position?: string;
    type?: string;
  }[];
  columns?: {
    field?: string;
    width?: number;
    align?: string;
    fixed?: string;
    wrap?: boolean;
  }[];
  denyUpdate?: boolean;
  denyRemove?: boolean;
  searchSettings?: string;
  highlight?: object;
}

export interface Notification {
  id?: string;
  tid?: string[];
  index?: string;
  /** @format date-time */
  date?: string;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface RecycleBin {
  id?: string;
  tid?: string[];
  name?: string;
  index?:
    | "file"
    | "gridDecorator"
    | "health"
    | "image"
    | "notification"
    | "recycleBin"
    | "report"
    | "securityGroup"
    | "taskManagement"
    | "template"
    | "user"
    | "versionManaged"
    | "aiPrompt"
    | "alert"
    | "area"
    | "businessObject"
    | "characteristic"
    | "city"
    | "company"
    | "contract"
    | "contractNumber"
    | "contractTemplate"
    | "country"
    | "deduplication"
    | "draft"
    | "exchangeRates"
    | "filesAndFolders"
    | "gridCustomField"
    | "jira"
    | "log"
    | "party"
    | "qualityControlRule"
    | "qualityControlScore"
    | "sync"
    | "timeline"
    | "vatCountry"
    | "db_version"
    | "globalSearch"
    | "invoice"
    | "invoiceNumber"
    | "invoiceProtocol"
    | "invoiceRule";
  data?: string;
  user?: {
    id: string;
    name?: string;
    image?: string;
  };
  company?: {
    id: string;
    name?: string;
  };
  denyUpdate?: boolean;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  name_en?: string;
  name_bg?: string;
  highlight?: object;
}

export interface SecurityGroup {
  id?: string;
  name?: string;
  defaultRights?: "all" | "read" | "create" | "update" | "remove" | "denied";
  parent?: string;
  index?: string;
  allTenants?: "allow" | "deny";
  rights?: {
    type?: "entityPermission" | "businessPermission";
    entity?: string;
    permissions?: (
      | "all"
      | "read"
      | "create"
      | "update"
      | "remove"
      | "denied"
    )[];
    filter?: {
      name?: string;
      value?: string[];
    }[];
    denyFields?: string[];
  }[];
  denyUpdate?: boolean;
  denyRemove?: boolean;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  name_en?: string;
  name_bg?: string;
  highlight?: object;
}

export interface TaskManagement {
  value?: string;
  highlight?: object;
}

export interface User {
  id?: string;
  tid?: string[];
  name?: string;
  description?: string;
  image?: string;
  company?: {
    id: string;
    name?: string;
  };
  email?: string;
  phone?: string;
  role?: {
    name_en?: string;
    name_bg?: string;
    name?: string;
    id: string;
  };
  shaNoise?: string;
  password?: string;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  suspended?: boolean;
  suspensionReason?: string;
  highlight?: object;
}

export interface AiPrompt {
  id?: string;
  type?:
    | "Extract Timeline Data"
    | "Evaluate Image Quality and Content"
    | "Match Invoice to Contracts"
    | "Group Annexes"
    | "Find Related Contract for Annex"
    | "Extract Structured Data from Annex"
    | "Extract Invoice Structured Data"
    | "Convert Invoice Images to Markdown"
    | "Extract Contract Structured Data"
    | "Find Document Relationships"
    | "Convert Image to Markdown (Gemini)"
    | "Classify Document"
    | "Extract New Contract Type";
  active?: boolean;
  name?: string;
  provider?: "gemini" | "anthropic";
  providerModel?:
    | "gemini-2.0-flash"
    | "gemini-2.5-flash"
    | "gemini-2.5-pro"
    | "claude-3-7-sonnet-latest";
  prompt?: string;
  denyUpdate?: boolean;
  denyRemove?: boolean;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface Alert {
  id?: string;
  tid?: string[];
  type?: "contractExpiration" | "qualityControl";
  name?: string;
  items?: {
    id: string;
    name?: string;
    _index?: string;
  }[];
  targetFields?: {
    name?: string;
    requiredValue?: string;
    actualValue?: string;
    dimension?: string;
  }[];
  user?: {
    id: string;
    name?: string;
    image?: string;
  };
  priority?: "low" | "normal" | "high" | "extreme";
  isRead?: boolean;
  company?: {
    id: string;
    name?: string;
    image?: string;
  };
  denyRemove?: boolean;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface Area {
  id?: string;
  name?: string;
  area?: string;
  country?: string;
  location?: {
    lat?: number;
    lon?: number;
  };
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  name_en?: string;
  name_bg?: string;
  highlight?: object;
}

export interface BusinessObject {
  id?: string;
  tid?: string[];
  name?: string;
  alias?: string[];
  gridName?: string;
  type?:
    | "building"
    | "apartment"
    | "commercialPremises"
    | "undergroundParkingSpace"
    | "garage"
    | "office"
    | "roomForSleeping"
    | "parkingLot"
    | "house"
    | "logisticsPark"
    | "administrativeBuildingAndOffice"
    | "administrativeBuildingAndArchive"
    | "land"
    | "courierServicesOffice"
    | "logisticsCenter"
    | "administrativeBuilding"
    | "academy"
    | "houseForOvernightStaysForBusinessTravelers"
    | "unspecified";
  mainObject?: {
    id: string;
    gridName?: string;
  };
  /** A distinguishing label or code used to tell apart multiple facilities that share the same type and/or address (e.g. 'Гараж 1', 'Обект 2'). Not a personal or legal signature. */
  signature?: string;
  uniqIdentifier?: string;
  addressIdentifier?: string;
  fullAddressIdentifier?: string;
  groupId?: string;
  code?: string;
  area?: {
    value?: number;
    dimension?: "sq_m";
  };
  image?: string;
  company?: {
    id: string;
    name?: string;
  };
  address?: {
    country?: {
      id?: string;
      name?: string;
      name_en?: string;
      name_bg?: string;
      required?: any;
    };
    state?: {
      id?: string;
      name?: string;
      name_en?: string;
      name_bg?: string;
      required?: any;
    };
    city?: {
      id?: string;
      name?: string;
      name_en?: string;
      name_bg?: string;
      required?: any;
    };
    /** Street name only, without number. */
    street?: string;
    /** The building number that identifies the exact location on the street. This may include numbers only (e.g., '12'), numbers with letters (e.g., '12A', '221B'), ranges (e.g., '12–14'), or compound formats (e.g., '12/1'). Do not include the street name here — only the number or alphanumeric identifier that comes after the street name. */
    streetNumber?: string;
    postcode?: string;
    floor?: string;
    apartment?: string;
    type?: "work" | "home" | "billing" | "other";
    entrance?: string;
    addressNote?: string;
  };
  email?: {
    type?: string;
    value: string;
    name?: string;
  }[];
  phone?: {
    type?: string;
    value: string;
    name?: string;
  }[];
  web?: string;
  workTime?: {
    "0"?: {
      from?: number;
      to?: number;
    }[];
    "1"?: {
      from?: number;
      to?: number;
    }[];
    "2"?: {
      from?: number;
      to?: number;
    }[];
    "3"?: {
      from?: number;
      to?: number;
    }[];
    "4"?: {
      from?: number;
      to?: number;
    }[];
    "5"?: {
      from?: number;
      to?: number;
    }[];
    "6"?: {
      from?: number;
      to?: number;
    }[];
    all?: {
      from?: number;
      to?: number;
    }[];
    workdays?: {
      from?: number;
      to?: number;
    }[];
  };
  currency?: "eur" | "bgn";
  vat?: {
    id: string;
    name?: string;
    scalar?: number;
    name_en?: string;
    name_bg?: string;
  };
  iban?: {
    identifier?: string;
    currency?: "eur" | "bgn";
    bic?: string;
    bank?: string;
  }[];
  countrySpecific?: {
    bg?: {
      bulstat?: string;
      zdds?: string;
    };
  };
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface Characteristic {
  id?: string;
  type?: string;
  parentType?: string;
  parentItem?: {
    name_en?: string;
    name_bg?: string;
    name?: string;
    id: string;
  }[];
  name?: string;
  description?: string;
  code?: string;
  scalar?: number;
  canReInvoicing?: boolean;
  active?: boolean;
  denyUpdate?: boolean;
  denyRemove?: boolean;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  name_en?: string;
  name_bg?: string;
  highlight?: object;
}

export interface City {
  id?: string;
  name?: string;
  area?: string;
  areaCenter?: boolean;
  country?: string;
  mapArea?: {
    lat?: number;
    lon?: number;
  }[];
  location?: {
    lat?: number;
    lon?: number;
  };
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  name_en?: string;
  name_bg?: string;
  highlight?: object;
}

export interface Company {
  id?: string;
  tid?: string[];
  name?: string;
  image?: string;
  address?: {
    country?: {
      id?: string;
      name?: string;
      name_en?: string;
      name_bg?: string;
      required?: any;
    };
    state?: {
      id?: string;
      name?: string;
      name_en?: string;
      name_bg?: string;
      required?: any;
    };
    city?: {
      id?: string;
      name?: string;
      name_en?: string;
      name_bg?: string;
      required?: any;
    };
    /** Street name only, without number. */
    street?: string;
    /** The building number that identifies the exact location on the street. This may include numbers only (e.g., '12'), numbers with letters (e.g., '12A', '221B'), ranges (e.g., '12–14'), or compound formats (e.g., '12/1'). Do not include the street name here — only the number or alphanumeric identifier that comes after the street name. */
    streetNumber?: string;
    postcode?: string;
    floor?: string;
    apartment?: string;
    type?: "work" | "home" | "billing" | "other";
    entrance?: string;
    addressNote?: string;
  };
  email?: {
    type?: string;
    value: string;
    name?: string;
  }[];
  phone?: {
    type?: string;
    value: string;
    name?: string;
  }[];
  web?: string;
  workTime?: {
    "0"?: {
      from?: number;
      to?: number;
    }[];
    "1"?: {
      from?: number;
      to?: number;
    }[];
    "2"?: {
      from?: number;
      to?: number;
    }[];
    "3"?: {
      from?: number;
      to?: number;
    }[];
    "4"?: {
      from?: number;
      to?: number;
    }[];
    "5"?: {
      from?: number;
      to?: number;
    }[];
    "6"?: {
      from?: number;
      to?: number;
    }[];
    all?: {
      from?: number;
      to?: number;
    }[];
    workdays?: {
      from?: number;
      to?: number;
    }[];
  };
  headmaster?: string;
  identifier?: string;
  currency?: "eur" | "bgn";
  formatDate?:
    | "MM/DD/YYYY"
    | "DD/MM/YYYY"
    | "DD-MM-YYYY"
    | "YYYY-MM-DD"
    | "DD.MM.YYYY"
    | "YY/MM/DD";
  formatTime?: "hh:mm A" | "hh:mm a" | "HH:mm";
  formatNumber?: "$x,xxx.xx" | "x,xxx.xx $" | "x xxx,xx $" | "$x'xxx.xx";
  vat?: {
    id: string;
    name?: string;
    scalar?: number;
    name_en?: string;
    name_bg?: string;
  };
  iban?: {
    identifier?: string;
    currency?: "eur" | "bgn";
    bic?: string;
    bank?: string;
  }[];
  countrySpecific?: {
    bg?: {
      bulstat?: string;
      zdds?: string;
    };
  };
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface Contract {
  id?: string;
  tid?: string[];
  name?: string;
  uniqIdentifier?: string;
  number?: string;
  handwritten?: boolean;
  badQualityPages?: boolean;
  documentType?: "contract" | "agreement" | "order" | "offer";
  template?: {
    id: string;
    name?: string;
  };
  responsible?: {
    id: string;
    name?: string;
    image?: string;
  };
  /** Represents a list of client party involved in a contract. */
  from?: {
    id: string;
    name?: string;
  }[];
  /** Represents list of contractor party involved in a contract. */
  to?: {
    id: string;
    name?: string;
  }[];
  /** Represents contract type. */
  contractSubject?: {
    id: string;
    name?: string;
    name_en?: string;
    name_bg?: string;
  };
  contractSubjectSubCategory?: {
    id: string;
    name?: string;
    name_en?: string;
    name_bg?: string;
  };
  /** Represents a list of  facility covered by the contract. */
  businessObject?: {
    id: string;
    gridName?: string;
    name?: string;
  }[];
  periodType?:
    | "fixedTerm"
    | "IndefiniteTerm"
    | "untilCompletionWork"
    | "autoRenewal"
    | "trailPeriod";
  /** Represents contract period. */
  period?: {
    /**
     * Date when the contract becomes effective.
     * @format date-time
     */
    from?: string;
    /**
     * Date when the contract expires.
     * @format date-time
     */
    to?: string;
  };
  /**
   * Date when the contract was signed.
   * @format date-time
   */
  signingDate?: string;
  description?: string;
  paymentStatus?: "unpaid" | "partiallyPayed" | "payed";
  invoiceStatus?:
    | "draft"
    | "pendingApproval"
    | "notInvoiced"
    | "partiallyInvoiced"
    | "invoiced";
  invoice?: {
    id: string;
    /** Unique invoice number */
    number?: string;
    /** @format date-time */
    overdueDate?: string;
    period?: {
      /** @format date-time */
      from?: string;
      /** @format date-time */
      to?: string;
    };
  }[];
  company?: {
    id: string;
    name?: string;
    image?: string;
  };
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  custom_boolean?: {
    key?: string;
    value?: boolean;
    fullPath?: string;
    index?: number;
  }[];
  custom_number?: {
    key?: string;
    value?: number;
    fullPath?: string;
    index?: number;
  }[];
  custom_float?: {
    key?: string;
    value?: number;
    fullPath?: string;
    index?: number;
  }[];
  custom_string?: {
    key?: string;
    value?: string;
    fullPath?: string;
    index?: number;
  }[];
  custom_date?: {
    key?: string;
    /** @format date-time */
    value?: string;
    fullPath?: string;
    index?: number;
  }[];
  custom_geo_point?: {
    key?: string;
    value?: {
      lat?: number;
      lon?: number;
    };
    fullPath?: string;
    index?: number;
  }[];
  custom_dense_vector?: {
    key?: string;
    value?: number[];
    fullPath?: string;
    index?: number;
  }[];
  customFields?: {
    id: string;
    name?: string;
    type?:
      | "boolean"
      | "string"
      | "text"
      | "number"
      | "search"
      | "select"
      | "date"
      | "dateRange"
      | "currency"
      | "email"
      | "web"
      | "object"
      | "array";
    relatedIndex?: "characteristic" | "contract" | "businessObject" | "party";
    enumValues?: string[];
    required?: boolean;
    default?: boolean;
    fields?: {
      id?: string;
      name?: string;
      description?: string;
      type?:
        | "boolean"
        | "string"
        | "text"
        | "number"
        | "search"
        | "select"
        | "date"
        | "dateRange"
        | "currency"
        | "email"
        | "web";
      relatedIndex?: "characteristic" | "contract" | "businessObject" | "party";
      multiselect?: boolean;
      locale?: boolean;
      searchQuery?: {
        field?: string;
        searchType?: string;
        value?: string[];
      }[];
      enumValues?: string[];
      validators?: (
        | "number"
        | "email"
        | "float"
        | "floatNoZero"
        | "phone"
        | "password"
        | "name"
        | "uniqDb"
        | "web"
        | "bulstat"
        | "iban"
        | "bic"
        | "egn"
      )[];
    }[];
  }[];
  highlight?: object;
}

export interface ContractNumber {
  id?: string;
  tid?: string[];
  number?: number;
  numberLength?: number;
  prefix?: "empty" | "dateYM" | "dateY" | "name";
  suffix?: "empty" | "name";
  delimiter?: string;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface ContractTemplate {
  id?: string;
  tid?: string[];
  name?: string;
  description?: string;
  documentType?: "contract" | "agreement" | "order" | "offer";
  contractSubject?: {
    id: string;
    name?: string;
    name_en?: string;
    name_bg?: string;
  };
  contractSubjectSubCategory?: {
    id: string;
    name?: string;
    name_en?: string;
    name_bg?: string;
  };
  customFields?: {
    id: string;
    name?: string;
    type?:
      | "boolean"
      | "string"
      | "text"
      | "number"
      | "search"
      | "select"
      | "date"
      | "dateRange"
      | "currency"
      | "email"
      | "web"
      | "object"
      | "array";
    relatedIndex?: "characteristic" | "contract" | "businessObject" | "party";
    enumValues?: string[];
    required?: boolean;
    default?: boolean;
    fields?: {
      id?: string;
      name?: string;
      description?: string;
      type?:
        | "boolean"
        | "string"
        | "text"
        | "number"
        | "search"
        | "select"
        | "date"
        | "dateRange"
        | "currency"
        | "email"
        | "web";
      relatedIndex?: "characteristic" | "contract" | "businessObject" | "party";
      multiselect?: boolean;
      locale?: boolean;
      searchQuery?: {
        field?: string;
        searchType?: string;
        value?: string[];
      }[];
      enumValues?: string[];
      validators?: (
        | "number"
        | "email"
        | "float"
        | "floatNoZero"
        | "phone"
        | "password"
        | "name"
        | "uniqDb"
        | "web"
        | "bulstat"
        | "iban"
        | "bic"
        | "egn"
      )[];
    }[];
  }[];
  denyUpdate?: boolean;
  denyRemove?: boolean;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  description_en?: string;
  description_bg?: string;
  highlight?: object;
}

export interface Country {
  id?: string;
  name?: string;
  native?: string;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  name_en?: string;
  name_bg?: string;
  highlight?: object;
}

export interface Draft {
  id?: string;
  tid?: string[];
  name?: string;
  type?:
    | "annex"
    | "contract"
    | "schedule"
    | "invoice"
    | "receipt"
    | "payment_order"
    | "bank_statement"
    | "debit_note"
    | "credit_note"
    | "construction_permit"
    | "property_deed"
    | "personal_identification"
    | "disability_certificate"
    | "business_license"
    | "tax_certificate"
    | "insurance_certificate"
    | "regulatory_approval"
    | "notice"
    | "termination_notice"
    | "termination_agreement"
    | "demand_letter"
    | "dispute_resolution_document"
    | "handover_protocol"
    | "maintenance_report"
    | "utility_bill"
    | "proforma_invoice"
    | "inventory_list"
    | "work_order"
    | "service_report"
    | "completion_certificate"
    | "inspection_report"
    | "progress_report"
    | "audit_report"
    | "guarantee_certificate"
    | "memorandum_of_understanding"
    | "letter_of_intent"
    | "non_disclosure_agreement"
    | "power_of_attorney"
    | "security_deposit_agreement"
    | "employment_agreement"
    | "invoice_protocol"
    | "invoice_description"
    | "original"
    | "other"
    | "property_handover_protocol"
    | "invoice_acceptance_protocol"
    | "work_completion_handover_protocol"
    | "settlement_agreement"
    | "blank_pages"
    | "mortgage_deed"
    | "cadastral_plan"
    | "payment_statement"
    | "approval_request"
    | "approval_acknowledgment";
  user?: {
    id: string;
    name?: string;
    image?: string;
  };
  data?: string;
  denyUpdate?: boolean;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface ExchangeRates {
  id?: string;
  from?: "eur" | "bgn";
  to?: "eur" | "bgn";
  value?: number;
  maxDiff?: number;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface FilesAndFolders {
  id?: string;
  tid?: string[];
  groupId?: string;
  uniqIdentifier?: string;
  name?: string;
  comment?: string;
  link?: string;
  originalFileLink?: string;
  originalName?: string;
  file?: string;
  linkType?: "file" | "web" | "image" | "phone" | "email";
  source?: string;
  highlights?: {
    id?: string;
    content?: string;
    position?: {
      boundingRect?: {
        x1?: number;
        y1?: number;
        x2?: number;
        y2?: number;
        width?: number;
        height?: number;
        pageNumber?: number;
      };
      rects?: {
        x1?: number;
        y1?: number;
        x2?: number;
        y2?: number;
        width?: number;
        height?: number;
        pageNumber?: number;
      }[];
      usePdfCoordinates?: boolean;
    };
    document?: string;
    comment?: string;
    color?: string;
    link?: string;
    type?: "highlight" | "freeDraw" | "textNote" | "relation";
  }[];
  contractHighlights?: string;
  structuredData?: string;
  datapointsWithPageQualities?: string;
  category?:
    | "annex"
    | "contract"
    | "schedule"
    | "invoice"
    | "receipt"
    | "payment_order"
    | "bank_statement"
    | "debit_note"
    | "credit_note"
    | "construction_permit"
    | "property_deed"
    | "personal_identification"
    | "disability_certificate"
    | "business_license"
    | "tax_certificate"
    | "insurance_certificate"
    | "regulatory_approval"
    | "notice"
    | "termination_notice"
    | "termination_agreement"
    | "demand_letter"
    | "dispute_resolution_document"
    | "handover_protocol"
    | "maintenance_report"
    | "utility_bill"
    | "proforma_invoice"
    | "inventory_list"
    | "work_order"
    | "service_report"
    | "completion_certificate"
    | "inspection_report"
    | "progress_report"
    | "audit_report"
    | "guarantee_certificate"
    | "memorandum_of_understanding"
    | "letter_of_intent"
    | "non_disclosure_agreement"
    | "power_of_attorney"
    | "security_deposit_agreement"
    | "employment_agreement"
    | "invoice_protocol"
    | "invoice_description"
    | "original"
    | "other"
    | "property_handover_protocol"
    | "invoice_acceptance_protocol"
    | "work_completion_handover_protocol"
    | "settlement_agreement"
    | "blank_pages"
    | "mortgage_deed"
    | "cadastral_plan"
    | "payment_statement"
    | "approval_request"
    | "approval_acknowledgment";
  relatedToFile?: {
    id: string;
    name?: string;
    startPage?: number;
    endPage?: number;
  };
  shareWithClient?: boolean;
  type?: "file" | "directory";
  systemType?:
    | "communication"
    | "meeting"
    | "unknown"
    | "other"
    | "hidden"
    | "original";
  parent?: string;
  representItem?: string;
  path?: {
    id: string;
    name?: string;
  }[];
  tags?: {
    id?: string;
    name?: string;
    color?: string;
    group?: string;
  }[];
  user?: {
    id: string;
    name?: string;
  };
  party?: {
    id: string;
    name?: string;
  };
  mimetype?: string;
  fileSize?: number;
  md5?: string;
  company?: {
    id: string;
    name?: string;
    image?: string;
  };
  contract?: {
    id: string;
    name?: string;
  };
  relatedToItem?: {
    name?: string;
    id: string;
    gridName?: string;
  }[];
  content?: string;
  activeMode?: "draft" | "normal";
  notProcessed?: boolean;
  denyUpdate?: boolean;
  denyRemove?: boolean;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface GridCustomField {
  id?: string;
  tid?: string[];
  name?: string;
  type?:
    | "boolean"
    | "string"
    | "text"
    | "number"
    | "search"
    | "select"
    | "date"
    | "dateRange"
    | "currency"
    | "email"
    | "web"
    | "object"
    | "array";
  index?: "contract" | "party";
  relatedIndex?: "characteristic" | "contract" | "businessObject" | "party";
  multiselect?: boolean;
  locale?: boolean;
  enumValues?: string[];
  validators?: (
    | "number"
    | "email"
    | "float"
    | "floatNoZero"
    | "phone"
    | "password"
    | "name"
    | "uniqDb"
    | "web"
    | "bulstat"
    | "iban"
    | "bic"
    | "egn"
  )[];
  fields?: {
    id?: string;
    name?: string;
    description?: string;
    type?:
      | "boolean"
      | "string"
      | "text"
      | "number"
      | "search"
      | "select"
      | "date"
      | "dateRange"
      | "currency"
      | "email"
      | "web";
    relatedIndex?: "characteristic" | "contract" | "businessObject" | "party";
    multiselect?: boolean;
    locale?: boolean;
    searchQuery?: {
      field?: string;
      searchType?: string;
      value?: string[];
    }[];
    enumValues?: string[];
    validators?: (
      | "number"
      | "email"
      | "float"
      | "floatNoZero"
      | "phone"
      | "password"
      | "name"
      | "uniqDb"
      | "web"
      | "bulstat"
      | "iban"
      | "bic"
      | "egn"
    )[];
  }[];
  default?: boolean;
  required?: boolean;
  description?: string;
  searchQuery?: {
    field?: string;
    searchType?: string;
    value?: string[];
  }[];
  canSort?: boolean;
  sortField?: string;
  canSearch?: boolean;
  searchField?: {
    field?: string;
    searchStrategy?: ("exact" | "edgeNgram" | "ngram")[];
    globalSearch?: boolean;
  }[];
  company?: {
    id: string;
    name?: string;
    image?: string;
  };
  denyUpdate?: boolean;
  denyRemove?: boolean;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface Log {
  id?: string;
  tid?: string[];
  severity?: "info" | "warn" | "error";
  type?: string;
  taskId?: string;
  name?: string;
  step?: string;
  environment?: "server" | "jira";
  user?: {
    id: string;
    name?: string;
    image?: string;
  };
  result?: string;
  denyUpdate?: boolean;
  denyRemove?: boolean;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface Party {
  id?: string;
  tid?: string[];
  type?: "company" | "person";
  name?: string;
  image?: string;
  /** @format date-time */
  birthDate?: string;
  email?: {
    type?: string;
    value: string;
    name?: string;
    primary?: boolean;
  }[];
  phone?: {
    type?: string;
    value: string;
    name?: string;
    primary?: boolean;
  }[];
  web?: {
    type?: string;
    value: string;
    primary?: boolean;
  }[];
  address?: {
    country?: {
      id?: string;
      name?: string;
      name_en?: string;
      name_bg?: string;
      required?: any;
    };
    state?: {
      id?: string;
      name?: string;
      name_en?: string;
      name_bg?: string;
      required?: any;
    };
    city?: {
      id?: string;
      name?: string;
      name_en?: string;
      name_bg?: string;
      required?: any;
    };
    /** Street name only, without number. */
    street?: string;
    /** The building number that identifies the exact location on the street. This may include numbers only (e.g., '12'), numbers with letters (e.g., '12A', '221B'), ranges (e.g., '12–14'), or compound formats (e.g., '12/1'). Do not include the street name here — only the number or alphanumeric identifier that comes after the street name. */
    streetNumber?: string;
    postcode?: string;
    floor?: string;
    apartment?: string;
    type?: "work" | "home" | "billing" | "other";
    entrance?: string;
    addressNote?: string;
  }[];
  oldParties?: {
    id: string;
    name?: string;
    /** For individuals this value is the personal identification number (PIN) and for businesses this value is the UIC number */
    uniqIdentifier?: string;
  }[];
  company?: {
    id: string;
    name?: string;
    image?: string;
  };
  headmaster?: string;
  currency?: "eur" | "bgn";
  iban?: {
    identifier?: string;
    currency?: "eur" | "bgn";
    bic?: string;
    bank?: string;
  }[];
  /** For individuals this value is the personal identification number (PIN) and for businesses this value is the UIC number */
  uniqIdentifier?: string;
  countrySpecific?: {
    bg?: {
      bulstat?: string;
      zdds?: string;
    };
    us?: {
      ledes?: string;
      taxId?: string;
    };
    en?: {
      ledes?: string;
      taxId?: string;
    };
  };
  role?: {
    name_en?: string;
    name_bg?: string;
    name?: string;
    id: string;
  };
  own?: boolean;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  custom_boolean?: {
    key?: string;
    value?: boolean;
    fullPath?: string;
    index?: number;
  }[];
  custom_number?: {
    key?: string;
    value?: number;
    fullPath?: string;
    index?: number;
  }[];
  custom_float?: {
    key?: string;
    value?: number;
    fullPath?: string;
    index?: number;
  }[];
  custom_string?: {
    key?: string;
    value?: string;
    fullPath?: string;
    index?: number;
  }[];
  custom_date?: {
    key?: string;
    /** @format date-time */
    value?: string;
    fullPath?: string;
    index?: number;
  }[];
  custom_geo_point?: {
    key?: string;
    value?: {
      lat?: number;
      lon?: number;
    };
    fullPath?: string;
    index?: number;
  }[];
  custom_dense_vector?: {
    key?: string;
    value?: number[];
    fullPath?: string;
    index?: number;
  }[];
  customFields?: {
    id: string;
    name?: string;
    type?:
      | "boolean"
      | "string"
      | "text"
      | "number"
      | "search"
      | "select"
      | "date"
      | "dateRange"
      | "currency"
      | "email"
      | "web"
      | "object"
      | "array";
    relatedIndex?: "characteristic" | "contract" | "businessObject" | "party";
    enumValues?: string[];
    required?: boolean;
    default?: boolean;
    fields?: {
      id?: string;
      name?: string;
      description?: string;
      type?:
        | "boolean"
        | "string"
        | "text"
        | "number"
        | "search"
        | "select"
        | "date"
        | "dateRange"
        | "currency"
        | "email"
        | "web";
      relatedIndex?: "characteristic" | "contract" | "businessObject" | "party";
      multiselect?: boolean;
      locale?: boolean;
      searchQuery?: {
        field?: string;
        searchType?: string;
        value?: string[];
      }[];
      enumValues?: string[];
      validators?: (
        | "number"
        | "email"
        | "float"
        | "floatNoZero"
        | "phone"
        | "password"
        | "name"
        | "uniqDb"
        | "web"
        | "bulstat"
        | "iban"
        | "bic"
        | "egn"
      )[];
    }[];
  }[];
  highlight?: object;
}

export interface QualityControlRule {
  id?: string;
  tid?: string[];
  name?: string;
  responsible?: {
    id: string;
    name?: string;
    image?: string;
  };
  contract?: {
    id: string;
    name?: string;
  };
  /** Represents a facility covered by the contract. */
  businessObject?: {
    id: string;
    gridName?: string;
  };
  /** Represents a contract object. */
  contractObject?: {
    id: string;
    name?: string;
    name_en?: string;
    name_bg?: string;
  };
  periodicity?: {
    period?: "weekly" | "monthly" | "yearly" | "afterJobComplete";
    dates?: string[];
  };
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface QualityControlScore {
  id?: string;
  tid?: string[];
  responsible?: {
    id: string;
    name?: string;
    image?: string;
  };
  contract?: {
    id: string;
    name?: string;
  };
  /** Represents a facility covered by the contract. */
  businessObject?: {
    id: string;
    gridName?: string;
  };
  /** Represents a contract object. */
  contractObject?: {
    id: string;
    name?: string;
    name_en?: string;
    name_bg?: string;
  };
  qualityControlRule?: {
    id: string;
    name?: string;
    contract?: {
      id: string;
      name?: string;
    };
    responsible?: {
      id: string;
      name?: string;
      image?: string;
    };
    /** Represents a facility covered by the contract. */
    businessObject?: {
      id: string;
      gridName?: string;
    };
    /** Represents a contract object. */
    contractObject?: {
      id: string;
      name?: string;
      name_en?: string;
      name_bg?: string;
    };
  };
  rating?: number;
  reason?: string;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface Sync {
  id?: string;
  tid?: string[];
  user?: {
    id: string;
    name?: string;
    image?: string;
  };
  type?:
    | "googleCalendar"
    | "microsoftCalendar"
    | "googleEmail"
    | "microsoftEmail"
    | "zoomMeeting"
    | "googleMeeting"
    | "microsoftMeeting"
    | "jira";
  active?: boolean;
  credentials?: string;
  profileName?: string;
  syncs?: {
    source?: {
      id?: string;
      name?: string;
    };
    target?: {
      id?: string;
      name?: string;
    };
    /** @format date-time */
    lastSync?: string;
    status?: "idle" | "inProgress" | "error";
    syncToken?: string;
    error?: string;
    warnings?: "noCloudRecording"[];
    result?: {
      total?: number;
      success?: number;
      warning?: number;
      error?: number;
    };
    query?: {
      /** @format date-time */
      from?: string;
    };
  }[];
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface Timeline {
  id?: string;
  changes?: string[];
  file?: {
    category?:
      | "annex"
      | "contract"
      | "schedule"
      | "invoice"
      | "receipt"
      | "payment_order"
      | "bank_statement"
      | "debit_note"
      | "credit_note"
      | "construction_permit"
      | "property_deed"
      | "personal_identification"
      | "disability_certificate"
      | "business_license"
      | "tax_certificate"
      | "insurance_certificate"
      | "regulatory_approval"
      | "notice"
      | "termination_notice"
      | "termination_agreement"
      | "demand_letter"
      | "dispute_resolution_document"
      | "handover_protocol"
      | "maintenance_report"
      | "utility_bill"
      | "proforma_invoice"
      | "inventory_list"
      | "work_order"
      | "service_report"
      | "completion_certificate"
      | "inspection_report"
      | "progress_report"
      | "audit_report"
      | "guarantee_certificate"
      | "memorandum_of_understanding"
      | "letter_of_intent"
      | "non_disclosure_agreement"
      | "power_of_attorney"
      | "security_deposit_agreement"
      | "employment_agreement"
      | "invoice_protocol"
      | "invoice_description"
      | "original"
      | "other"
      | "property_handover_protocol"
      | "invoice_acceptance_protocol"
      | "work_completion_handover_protocol"
      | "settlement_agreement"
      | "blank_pages"
      | "mortgage_deed"
      | "cadastral_plan"
      | "payment_statement"
      | "approval_request"
      | "approval_acknowledgment";
    name?: string;
    id: string;
  };
  /** @format date-time */
  date?: string;
  contract?: {
    name?: string;
    id: string;
  };
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface VatCountry {
  id?: string;
  country?: {
    id: string;
    name?: string;
    native?: string;
    name_en?: string;
    name_bg?: string;
  };
  value?: {
    id: string;
    name?: string;
    scalar?: number;
  };
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface Invoice {
  id?: string;
  tid?: string[];
  /** TYpe of the invoice */
  type?:
    | "invoice"
    | "advancePayment"
    | "creditNote"
    | "debitNote"
    | "reversalProtocol";
  /** Unique invoice number */
  number?: string;
  noteType?: "value" | "quantity";
  status?:
    | "draft"
    | "pendingApproval"
    | "unpaid"
    | "partiallyPayed"
    | "canceled"
    | "reversal"
    | "payed";
  /** Date of the taxable event or advance payment */
  period?: {
    /** @format date-time */
    from?: string;
    /** @format date-time */
    to?: string;
  };
  /** @format date-time */
  overdueDate?: string;
  price?: {
    value: number;
    currency: "eur" | "bgn";
  };
  /** Taxable amount before VAT */
  priceNoVat?: {
    value: number;
    currency: "eur" | "bgn";
  };
  discount?: {
    value: number;
    currency: "eur" | "bgn";
  };
  discountPrice?: {
    value: number;
    currency: "eur" | "bgn";
  };
  discountPriceNoVat?: {
    value: number;
    currency: "eur" | "bgn";
  };
  /** VAT percentage applied */
  vat?: {
    vatValue?: number;
    price?: {
      value: number;
      currency: "eur" | "bgn";
    };
  }[];
  /** Amount of VAT applied */
  totalVat?: {
    value: number;
    currency: "eur" | "bgn";
  };
  /** Total amount to be paid including VAT */
  finalPrice?: {
    value: number;
    currency: "eur" | "bgn";
  };
  finalAggPrice?: {
    value: number;
    currency: "eur" | "bgn";
  };
  partiallyPayed?: {
    value: number;
    currency: "eur" | "bgn";
  };
  advancePayment?: {
    value: number;
    currency: "eur" | "bgn";
  };
  fromCompany?: {
    id: string;
    name?: string;
  };
  toCompany?: {
    id: string;
    name?: string;
  };
  paymentHistory?: {
    id?: string;
    identifier?: string;
    /** @format date-time */
    date?: string;
    payed?: {
      value: number;
      currency: "eur" | "bgn";
    };
    advance?: boolean;
    originalAmount?: {
      value?: number;
      currency?: string;
    };
  }[];
  /** List of items or services in the invoice */
  items?: {
    id?: string;
    type?: string;
    reInvoice?: boolean;
    description?: string;
    /** @format date-time */
    date?: string;
    subject?: {
      id?: string;
      name?: string;
      name_en?: string;
      name_bg?: string;
      required?: any;
    };
    contract?: {
      id?: string;
      name?: string;
      required?: any;
    };
    businessObject?: {
      id?: string;
      gridName?: string;
      name?: string;
      required?: any;
    };
    quantity?: number;
    dimension?: string;
    singlePriceNoVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalPriceNoVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalPriceDiscount?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalPriceDiscountNoVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    singlePriceDiscountNoVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    singlePriceDiscount?: {
      value: number;
      currency: "eur" | "bgn";
    };
    singleDiscount?: {
      value: number;
      currency: "eur" | "bgn";
    };
    singleDiscountAfterVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalDiscount?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalDiscountAfterVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    singleVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    singlePrice?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalPrice?: {
      value: number;
      currency: "eur" | "bgn";
    };
    vatValue?: number;
    [key: string]: any;
  }[];
  fullItemsList?: {
    id?: string;
    type?: string;
    name?: string;
    parent?: {
      id?: string;
      name?: string;
      type?: string;
    };
    package?: string;
    packageQuantity?: number;
    quantity?: number;
    quality?: string;
    dimension?: string;
    singlePriceNoVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalPriceNoVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalPriceDiscount?: {
      value: number;
      currency: "eur" | "bgn";
    };
    singlePriceDiscount?: {
      value: number;
      currency: "eur" | "bgn";
    };
    singleDiscount?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalDiscount?: {
      value: number;
      currency: "eur" | "bgn";
    };
    singleVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    singlePrice?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalPrice?: {
      value: number;
      currency: "eur" | "bgn";
    };
    vatValue?: number;
    [key: string]: any;
  }[];
  promoItemsList?: {
    id?: string;
    type?: string;
    name?: string;
    parent?: {
      id?: string;
      name?: string;
      type?: string;
    };
    package?: string;
    packageQuantity?: number;
    quantity?: number;
    quality?: string;
    dimension?: string;
    singlePriceNoVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalPriceNoVat?: {
      value: number;
      currency: "eur" | "bgn";
    };
    singlePrice?: {
      value: number;
      currency: "eur" | "bgn";
    };
    totalPrice?: {
      value: number;
      currency: "eur" | "bgn";
    };
    [key: string]: any;
  }[];
  cancelReason?: string;
  deliveryStatus?: "notSent" | "sent" | "delivered";
  related?: {
    id: string;
    number?: string;
    /** TYpe of the invoice */
    type?:
      | "invoice"
      | "advancePayment"
      | "creditNote"
      | "debitNote"
      | "reversalProtocol";
    actionsList?: {
      actionType?: "sent" | "delivered";
      /** @format date-time */
      date?: string;
      user?: {
        id?: string;
        name?: string;
      };
    }[];
  }[];
  actionsList?: {
    actionType?: "sent" | "delivered";
    /** @format date-time */
    date?: string;
    user?: {
      id?: string;
      name?: string;
    };
  }[];
  forApproveDescription?: string;
  /** @format date-time */
  dateForApprove?: string;
  sendEmail?: boolean;
  /** @format date-time */
  dateApprove?: string;
  user?: {
    id: string;
    name?: string;
    image?: string;
  };
  sendForApprove?: {
    id: string;
    name?: string;
    image?: string;
  }[];
  approvedFor?: {
    id: string;
    name?: string;
    image?: string;
  };
  denyUpdate?: boolean;
  denyRemove?: boolean;
  /** @format date-time */
  date_updated?: string;
  /** @format date-time */
  date_created?: string;
  /** Тhe amount of the discount applied after tax has been applied to the invoice amount */
  discountAfterVat?: {
    value: number;
    currency: "eur" | "bgn";
  };
  file?: {
    id: string;
    name?: string;
  };
  highlight?: object;
}

export interface InvoiceNumber {
  id?: string;
  tid?: string[];
  invoiceNo?: number;
  numberLength?: number;
  prefix?: string;
  suffix?: string;
  /** @format date-time */
  date_created?: string;
  /** @format date-time */
  date_updated?: string;
  highlight?: object;
}

export interface InvoiceProtocol {
  id?: string;
  tid?: string[];
  number?: string;
  fromCompany?: {
    id: string;
    name?: string;
  };
  toCompany?: {
    id: string;
    name?: string;
  };
  related?: {
    id: string;
    /** Unique invoice number */
    number?: string;
    /** TYpe of the invoice */
    type?:
      | "invoice"
      | "advancePayment"
      | "creditNote"
      | "debitNote"
      | "reversalProtocol";
    documentType?: "oldDocument" | "newDocument";
  }[];
  deliveryStatus?: "notSent" | "sent" | "delivered";
  actionsList?: {
    actionType?: "sent" | "delivered";
    /** @format date-time */
    date?: string;
    user?: {
      id?: string;
      name?: string;
    };
  }[];
  /** @format date-time */
  date_updated?: string;
  /** @format date-time */
  date_created?: string;
  highlight?: object;
}

export interface InvoiceRule {
  id?: string;
  tid?: string[];
  invoicePeriod?: "month" | "halfMonth" | "everyAction";
  paymentMethod?: "bank" | "cash";
  invoiceGenerationMethod?: "auto" | "manual";
  creditTerm?: number;
  creditLimitValue?: {
    name?: string;
    value?: number;
    type?: "money";
  }[];
  fromCompany?: {
    id: string;
    name?: string;
  };
  toCompany?: {
    id: string;
    name?: string;
  };
  /** @format date-time */
  date_updated?: string;
  /** @format date-time */
  date_created?: string;
  highlight?: object;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "/api";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key] instanceof Array ? input[key] : [input[key]];
        property.forEach((property: any) => {
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === "object" && property !== null
                  ? JSON.stringify(property)
                  : `${property}`
            )
        });
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Server API
 * @version 0.0.1
 * @baseUrl /api
 *
 * Swagger Schema Generator
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  file = {
    /**
     * No description
     *
     * @tags file
     * @name UploadFile
     * @request POST:/upload/file
     * @secure
     */
    uploadFile: (
      data: {
        file?: File;
        denySaving?: boolean;
        convertType?: string;
        textFormat?: "text" | "html" | "md";
        rights?: "public" | "private";
        path?: string;
        actions?: ("optimizeImage" | "textract" | "preview" | "convert")[];
        [key: string]: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            success?: boolean;
            task_id?: string;
            upload_task_id?: string;
            name?: string;
            md5?: string;
            file?: {
              filename?: string;
              originalname?: string;
              mimetype?: string;
              size?: number;
              [key: string]: any;
            };
          };
        },
        ErrorResponse
      >({
        path: `/upload/file`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags file
     * @name DownloadFile
     * @request GET:/upload/file
     * @secure
     */
    downloadFile: (
      query: {
        file_name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<File, ErrorResponse>({
        path: `/upload/file`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags file
     * @name UploadsFile
     * @request POST:/uploads/file
     * @secure
     */
    uploadsFile: (
      data: {
        files?: File[];
        convertType?: string;
        rights?: "public" | "private";
        path?: string;
        actions?: ("optimizeImage" | "textract" | "preview" | "convert")[];
        [key: string]: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            success?: boolean;
            data?: any[];
          };
        },
        ErrorResponse
      >({
        path: `/uploads/file`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags file
     * @name ReadStreamFile
     * @request GET:/file/readStreamFile
     */
    readStreamFile: (
      query: {
        path: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: any;
        },
        ErrorResponse
      >({
        path: `/file/readStreamFile`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags file
     * @name UrlToPdfFile
     * @request GET:/file/urlToPdf
     * @secure
     */
    urlToPdfFile: (
      query: {
        url: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: any;
        },
        ErrorResponse
      >({
        path: `/file/urlToPdf`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  gridDecorator = {
    /**
     * No description
     *
     * @tags gridDecorator
     * @name ReadGridDecorator
     * @request GET:/gridDecorator
     * @secure
     */
    readGridDecorator: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: GridDecorator;
        },
        ErrorResponse
      >({
        path: `/gridDecorator`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags gridDecorator
     * @name CreateGridDecorator
     * @request POST:/gridDecorator
     * @secure
     */
    createGridDecorator: (data: GridDecorator, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: GridDecorator;
        },
        ErrorResponse
      >({
        path: `/gridDecorator`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags gridDecorator
     * @name UpdateGridDecorator
     * @request PUT:/gridDecorator
     * @secure
     */
    updateGridDecorator: (data: GridDecorator, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: GridDecorator;
        },
        ErrorResponse
      >({
        path: `/gridDecorator`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags gridDecorator
     * @name RemoveGridDecorator
     * @request DELETE:/gridDecorator
     * @secure
     */
    removeGridDecorator: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: GridDecorator;
        },
        ErrorResponse
      >({
        path: `/gridDecorator`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags gridDecorator
     * @name SearchGridDecorator
     * @request GET:/gridDecorator/search
     * @secure
     */
    searchGridDecorator: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        parent?: string;
        active?: boolean;
        userId?: string;
        default?: boolean;
        system?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: GridDecorator[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/gridDecorator/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  health = {
    /**
     * No description
     *
     * @tags health
     * @name ServicesHealth
     * @request GET:/health
     */
    servicesHealth: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: any[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/health`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  image = {
    /**
     * No description
     *
     * @tags image
     * @name UploadImage
     * @request POST:/upload/image
     * @secure
     */
    uploadImage: (
      data: {
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
        },
        ErrorResponse
      >({
        path: `/upload/image`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  notification = {
    /**
     * No description
     *
     * @tags notification
     * @name ReadNotificationCount
     * @request GET:/notification
     * @secure
     */
    readNotificationCount: (params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            count?: number;
            index?: string;
            date?: string;
            name?: string;
          }[];
        },
        ErrorResponse
      >({
        path: `/notification`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags notification
     * @name UpdateNotificationAsRead
     * @request PUT:/notification
     * @secure
     */
    updateNotificationAsRead: (
      data: Notification,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
        },
        ErrorResponse
      >({
        path: `/notification`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  recycleBin = {
    /**
     * No description
     *
     * @tags recycleBin
     * @name ReadRecycleBin
     * @request GET:/recycleBin
     * @secure
     */
    readRecycleBin: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: RecycleBin;
        },
        ErrorResponse
      >({
        path: `/recycleBin`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags recycleBin
     * @name CreateRecycleBin
     * @request POST:/recycleBin
     * @secure
     */
    createRecycleBin: (data: RecycleBin, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: RecycleBin;
        },
        ErrorResponse
      >({
        path: `/recycleBin`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags recycleBin
     * @name UpdateRecycleBin
     * @request PUT:/recycleBin
     * @secure
     */
    updateRecycleBin: (data: RecycleBin, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: RecycleBin;
        },
        ErrorResponse
      >({
        path: `/recycleBin`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags recycleBin
     * @name RemoveRecycleBin
     * @request DELETE:/recycleBin
     * @secure
     */
    removeRecycleBin: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: RecycleBin;
        },
        ErrorResponse
      >({
        path: `/recycleBin`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags recycleBin
     * @name SearchRecycleBin
     * @request GET:/recycleBin/search
     * @secure
     */
    searchRecycleBin: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        name?: string;
        index?: (
          | "file"
          | "gridDecorator"
          | "health"
          | "image"
          | "notification"
          | "recycleBin"
          | "report"
          | "securityGroup"
          | "taskManagement"
          | "template"
          | "user"
          | "versionManaged"
          | "aiPrompt"
          | "alert"
          | "area"
          | "businessObject"
          | "characteristic"
          | "city"
          | "company"
          | "contract"
          | "contractNumber"
          | "contractTemplate"
          | "country"
          | "deduplication"
          | "draft"
          | "exchangeRates"
          | "filesAndFolders"
          | "gridCustomField"
          | "jira"
          | "log"
          | "party"
          | "qualityControlRule"
          | "qualityControlScore"
          | "sync"
          | "timeline"
          | "vatCountry"
          | "db_version"
          | "globalSearch"
          | "invoice"
          | "invoiceNumber"
          | "invoiceProtocol"
          | "invoiceRule"
        )[];
        user?: string;
        company?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: RecycleBin[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/recycleBin/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags recycleBin
     * @name RestoreFromRecycleBin
     * @request GET:/recycleBin/restoreFromRecycleBin
     * @secure
     */
    restoreFromRecycleBin: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: RecycleBin;
        },
        ErrorResponse
      >({
        path: `/recycleBin/restoreFromRecycleBin`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags recycleBin
     * @name EmptyRecycleBin
     * @request GET:/recycleBin/emptyRecycleBin
     * @secure
     */
    emptyRecycleBin: (params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: RecycleBin;
        },
        ErrorResponse
      >({
        path: `/recycleBin/emptyRecycleBin`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  report = {
    /**
     * No description
     *
     * @tags report
     * @name Report
     * @request GET:/report
     * @secure
     */
    report: (
      query: {
        reportName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: any[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/report`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  securityGroup = {
    /**
     * No description
     *
     * @tags securityGroup
     * @name ReadSecurityGroup
     * @request GET:/securityGroup
     * @secure
     */
    readSecurityGroup: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: SecurityGroup;
        },
        ErrorResponse
      >({
        path: `/securityGroup`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags securityGroup
     * @name CreateSecurityGroup
     * @request POST:/securityGroup
     * @secure
     */
    createSecurityGroup: (data: SecurityGroup, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: SecurityGroup;
        },
        ErrorResponse
      >({
        path: `/securityGroup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags securityGroup
     * @name UpdateSecurityGroup
     * @request PUT:/securityGroup
     * @secure
     */
    updateSecurityGroup: (data: SecurityGroup, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: SecurityGroup;
        },
        ErrorResponse
      >({
        path: `/securityGroup`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags securityGroup
     * @name RemoveSecurityGroup
     * @request DELETE:/securityGroup
     * @secure
     */
    removeSecurityGroup: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: SecurityGroup;
        },
        ErrorResponse
      >({
        path: `/securityGroup`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags securityGroup
     * @name SearchSecurityGroup
     * @request GET:/securityGroup/search
     * @secure
     */
    searchSecurityGroup: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        name?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: SecurityGroup[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/securityGroup/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  taskManagement = {
    /**
     * No description
     *
     * @tags taskManagement
     * @name ReadTaskManagement
     * @request GET:/taskManagement
     * @secure
     */
    readTaskManagement: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: TaskManagement;
        },
        ErrorResponse
      >({
        path: `/taskManagement`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags taskManagement
     * @name CreateTaskManagement
     * @request POST:/taskManagement
     * @secure
     */
    createTaskManagement: (data: TaskManagement, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: TaskManagement;
        },
        ErrorResponse
      >({
        path: `/taskManagement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags taskManagement
     * @name UpdateTaskManagement
     * @request PUT:/taskManagement
     * @secure
     */
    updateTaskManagement: (data: TaskManagement, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: TaskManagement;
        },
        ErrorResponse
      >({
        path: `/taskManagement`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags taskManagement
     * @name RemoveTaskManagement
     * @request DELETE:/taskManagement
     * @secure
     */
    removeTaskManagement: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: TaskManagement;
        },
        ErrorResponse
      >({
        path: `/taskManagement`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags taskManagement
     * @name CancelTaskManagement
     * @request POST:/task/cancelTaskManagement
     * @secure
     */
    cancelTaskManagement: (data: any, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: TaskManagement;
        },
        ErrorResponse
      >({
        path: `/task/cancelTaskManagement`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  template = {
    /**
     * No description
     *
     * @tags template
     * @name PrepareTemplate
     * @request POST:/template
     * @secure
     */
    prepareTemplate: (
      data: {
        templateName?: string;
        type: "csv" | "pdf" | "xlsx";
        settings?: Record<string, any>;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            success?: boolean;
            taskId?: string;
          };
        },
        ErrorResponse
      >({
        path: `/template`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags template
     * @name DownloadTemplate
     * @request GET:/template
     * @secure
     */
    downloadTemplate: (
      query: {
        file_name: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<File, ErrorResponse>({
        path: `/template`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags user
     * @name ReadUser
     * @request GET:/user
     * @secure
     */
    readUser: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: User;
        },
        ErrorResponse
      >({
        path: `/user`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name RegisterUser
     * @request POST:/user
     */
    registerUser: (data: User, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            success?: boolean;
            token?: string;
            data?: User;
          };
        },
        ErrorResponse
      >({
        path: `/user`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name UpdateUser
     * @request PUT:/user
     * @secure
     */
    updateUser: (data: User, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: User;
        },
        ErrorResponse
      >({
        path: `/user`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name RemoveUser
     * @request DELETE:/user
     * @secure
     */
    removeUser: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: User;
        },
        ErrorResponse
      >({
        path: `/user`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name CreateUser
     * @request POST:/user/create
     * @secure
     */
    createUser: (data: User, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: User;
        },
        ErrorResponse
      >({
        path: `/user/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name LoginUser
     * @request POST:/user/login
     */
    loginUser: (
      data: {
        email?: string;
        password?: string;
        code?: string;
        publicUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            token?: string;
            user?: User;
          };
        },
        ErrorResponse
      >({
        path: `/user/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name LoginConfirmUser
     * @request POST:/user/loginConfirm
     */
    loginConfirmUser: (
      data: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            token?: string;
            code?: string;
            type?: string;
            user?: User;
            error?: number;
            message?: string;
          };
        },
        ErrorResponse
      >({
        path: `/user/loginConfirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name LogoutUser
     * @request POST:/user/logout
     */
    logoutUser: (data: User, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
        },
        ErrorResponse
      >({
        path: `/user/logout`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name SearchUser
     * @request GET:/user/search
     * @secure
     */
    searchUser: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        name?: string;
        company?: string;
        email?: string;
        phone?: string;
        role?: string;
        suspended?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: User[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/user/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name ImpersonateUser
     * @request POST:/user/impersonate
     * @secure
     */
    impersonateUser: (data: User, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            token?: string;
            user?: User;
          };
        },
        ErrorResponse
      >({
        path: `/user/impersonate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  versionManaged = {
    /**
     * No description
     *
     * @tags versionManaged
     * @name DbVersionVersionManaged
     * @request GET:/versionManaged
     * @secure
     */
    dbVersionVersionManaged: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: any;
        },
        ErrorResponse
      >({
        path: `/versionManaged`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags versionManaged
     * @name AppVersionVersionManaged
     * @request GET:/version/appVersion
     * @secure
     */
    appVersionVersionManaged: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: any;
        },
        ErrorResponse
      >({
        path: `/version/appVersion`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags versionManaged
     * @name AppHistoryVersionVersionManaged
     * @request GET:/version/appHistory
     * @secure
     */
    appHistoryVersionVersionManaged: (
      query?: {
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: any;
        },
        ErrorResponse
      >({
        path: `/version/appHistory`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  aiPrompt = {
    /**
     * No description
     *
     * @tags aiPrompt
     * @name ReadAiPrompt
     * @request GET:/aiPrompt
     * @secure
     */
    readAiPrompt: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: AiPrompt;
        },
        ErrorResponse
      >({
        path: `/aiPrompt`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags aiPrompt
     * @name CreateAiPrompt
     * @request POST:/aiPrompt
     * @secure
     */
    createAiPrompt: (data: AiPrompt, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: AiPrompt;
        },
        ErrorResponse
      >({
        path: `/aiPrompt`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags aiPrompt
     * @name UpdateAiPrompt
     * @request PUT:/aiPrompt
     * @secure
     */
    updateAiPrompt: (data: AiPrompt, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: AiPrompt;
        },
        ErrorResponse
      >({
        path: `/aiPrompt`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags aiPrompt
     * @name RemoveAiPrompt
     * @request DELETE:/aiPrompt
     * @secure
     */
    removeAiPrompt: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: AiPrompt;
        },
        ErrorResponse
      >({
        path: `/aiPrompt`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags aiPrompt
     * @name SearchAiPrompt
     * @request GET:/aiPrompt/search
     * @secure
     */
    searchAiPrompt: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        type?: (
          | "Extract Timeline Data"
          | "Evaluate Image Quality and Content"
          | "Match Invoice to Contracts"
          | "Group Annexes"
          | "Find Related Contract for Annex"
          | "Extract Structured Data from Annex"
          | "Extract Invoice Structured Data"
          | "Convert Invoice Images to Markdown"
          | "Extract Contract Structured Data"
          | "Find Document Relationships"
          | "Convert Image to Markdown (Gemini)"
          | "Classify Document"
          | "Extract New Contract Type"
        )[];
        active?: boolean;
        name?: string;
        provider?: ("gemini" | "anthropic")[];
        providerModel?: (
          | "gemini-2.0-flash"
          | "gemini-2.5-flash"
          | "gemini-2.5-pro"
          | "claude-3-7-sonnet-latest"
        )[];
        denyRemove?: boolean;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: AiPrompt[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/aiPrompt/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  alert = {
    /**
     * No description
     *
     * @tags alert
     * @name ReadAlert
     * @request GET:/alert
     * @secure
     */
    readAlert: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Alert;
        },
        ErrorResponse
      >({
        path: `/alert`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags alert
     * @name CreateAlert
     * @request POST:/alert
     * @secure
     */
    createAlert: (data: Alert, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Alert;
        },
        ErrorResponse
      >({
        path: `/alert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags alert
     * @name UpdateAlert
     * @request PUT:/alert
     * @secure
     */
    updateAlert: (data: Alert, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Alert;
        },
        ErrorResponse
      >({
        path: `/alert`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags alert
     * @name RemoveAlert
     * @request DELETE:/alert
     * @secure
     */
    removeAlert: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Alert;
        },
        ErrorResponse
      >({
        path: `/alert`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags alert
     * @name SearchAlert
     * @request GET:/alert/search
     * @secure
     */
    searchAlert: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        type?: ("contractExpiration" | "qualityControl")[];
        user?: string;
        priority?: ("low" | "normal" | "high" | "extreme")[];
        isRead?: boolean;
        company?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Alert[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/alert/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  area = {
    /**
     * No description
     *
     * @tags area
     * @name ReadArea
     * @request GET:/area
     * @secure
     */
    readArea: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Area;
        },
        ErrorResponse
      >({
        path: `/area`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags area
     * @name CreateArea
     * @request POST:/area
     * @secure
     */
    createArea: (data: Area, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Area;
        },
        ErrorResponse
      >({
        path: `/area`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags area
     * @name UpdateArea
     * @request PUT:/area
     * @secure
     */
    updateArea: (data: Area, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Area;
        },
        ErrorResponse
      >({
        path: `/area`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags area
     * @name RemoveArea
     * @request DELETE:/area
     * @secure
     */
    removeArea: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Area;
        },
        ErrorResponse
      >({
        path: `/area`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags area
     * @name SearchArea
     * @request GET:/area/search
     * @secure
     */
    searchArea: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        name?: string;
        area?: string;
        country?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Area[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/area/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  businessObject = {
    /**
     * No description
     *
     * @tags businessObject
     * @name ReadBusinessObject
     * @request GET:/businessObject
     * @secure
     */
    readBusinessObject: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: BusinessObject;
        },
        ErrorResponse
      >({
        path: `/businessObject`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags businessObject
     * @name CreateBusinessObject
     * @request POST:/businessObject
     * @secure
     */
    createBusinessObject: (data: BusinessObject, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: BusinessObject;
        },
        ErrorResponse
      >({
        path: `/businessObject`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags businessObject
     * @name UpdateBusinessObject
     * @request PUT:/businessObject
     * @secure
     */
    updateBusinessObject: (data: BusinessObject, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: BusinessObject;
        },
        ErrorResponse
      >({
        path: `/businessObject`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags businessObject
     * @name RemoveBusinessObject
     * @request DELETE:/businessObject
     * @secure
     */
    removeBusinessObject: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: BusinessObject;
        },
        ErrorResponse
      >({
        path: `/businessObject`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags businessObject
     * @name SearchBusinessObject
     * @request GET:/businessObject/search
     * @secure
     */
    searchBusinessObject: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        alias?: string;
        gridName?: string;
        type?: (
          | "building"
          | "apartment"
          | "commercialPremises"
          | "undergroundParkingSpace"
          | "garage"
          | "office"
          | "roomForSleeping"
          | "parkingLot"
          | "house"
          | "logisticsPark"
          | "administrativeBuildingAndOffice"
          | "administrativeBuildingAndArchive"
          | "land"
          | "courierServicesOffice"
          | "logisticsCenter"
          | "administrativeBuilding"
          | "academy"
          | "houseForOvernightStaysForBusinessTravelers"
          | "unspecified"
        )[];
        mainObject?: string;
        signature?: string;
        uniqIdentifier?: string;
        addressIdentifier?: string;
        fullAddressIdentifier?: string;
        groupId?: string;
        code?: string;
        company?: string;
        address?: string;
        "address.country.name"?: string;
        "address.country.id"?: string;
        "address.city.name"?: string;
        "address.city.id"?: string;
        "address.street"?: string;
        "address.streetNumber"?: string;
        email?: string;
        phone?: string;
        currency?: ("eur" | "bgn")[];
        vat?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: BusinessObject[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/businessObject/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  characteristic = {
    /**
     * No description
     *
     * @tags characteristic
     * @name ReadCharacteristic
     * @request GET:/characteristic
     * @secure
     */
    readCharacteristic: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Characteristic;
        },
        ErrorResponse
      >({
        path: `/characteristic`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags characteristic
     * @name CreateCharacteristic
     * @request POST:/characteristic
     * @secure
     */
    createCharacteristic: (data: Characteristic, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Characteristic;
        },
        ErrorResponse
      >({
        path: `/characteristic`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags characteristic
     * @name UpdateCharacteristic
     * @request PUT:/characteristic
     * @secure
     */
    updateCharacteristic: (data: Characteristic, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Characteristic;
        },
        ErrorResponse
      >({
        path: `/characteristic`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags characteristic
     * @name RemoveCharacteristic
     * @request DELETE:/characteristic
     * @secure
     */
    removeCharacteristic: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Characteristic;
        },
        ErrorResponse
      >({
        path: `/characteristic`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags characteristic
     * @name SearchCharacteristic
     * @request GET:/characteristic/search
     * @secure
     */
    searchCharacteristic: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        type?: string;
        parentType?: string;
        parentItem?: string;
        name?: string;
        code?: string;
        fromScalar?: number;
        toScalar?: number;
        canReInvoicing?: boolean;
        active?: boolean;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Characteristic[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/characteristic/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  city = {
    /**
     * No description
     *
     * @tags city
     * @name ReadCity
     * @request GET:/city
     * @secure
     */
    readCity: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: City;
        },
        ErrorResponse
      >({
        path: `/city`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags city
     * @name CreateCity
     * @request POST:/city
     * @secure
     */
    createCity: (data: City, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: City;
        },
        ErrorResponse
      >({
        path: `/city`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags city
     * @name UpdateCity
     * @request PUT:/city
     * @secure
     */
    updateCity: (data: City, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: City;
        },
        ErrorResponse
      >({
        path: `/city`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags city
     * @name RemoveCity
     * @request DELETE:/city
     * @secure
     */
    removeCity: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: City;
        },
        ErrorResponse
      >({
        path: `/city`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags city
     * @name SearchCity
     * @request GET:/city/search
     * @secure
     */
    searchCity: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        name?: string;
        area?: string;
        areaCenter?: boolean;
        country?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: City[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/city/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  company = {
    /**
     * No description
     *
     * @tags company
     * @name ReadCompany
     * @request GET:/company
     * @secure
     */
    readCompany: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Company;
        },
        ErrorResponse
      >({
        path: `/company`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags company
     * @name CreateCompany
     * @request POST:/company
     * @secure
     */
    createCompany: (data: Company, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Company;
        },
        ErrorResponse
      >({
        path: `/company`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags company
     * @name UpdateCompany
     * @request PUT:/company
     * @secure
     */
    updateCompany: (data: Company, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Company;
        },
        ErrorResponse
      >({
        path: `/company`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags company
     * @name RemoveCompany
     * @request DELETE:/company
     * @secure
     */
    removeCompany: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Company;
        },
        ErrorResponse
      >({
        path: `/company`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags company
     * @name SearchCompany
     * @request GET:/company/search
     * @secure
     */
    searchCompany: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        name?: string;
        address?: string;
        email?: string;
        phone?: string;
        headmaster?: string;
        identifier?: string;
        currency?: ("eur" | "bgn")[];
        vat?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Company[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/company/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  contract = {
    /**
     * No description
     *
     * @tags contract
     * @name ReadContract
     * @request GET:/contract
     * @secure
     */
    readContract: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Contract;
        },
        ErrorResponse
      >({
        path: `/contract`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contract
     * @name CreateContract
     * @request POST:/contract
     * @secure
     */
    createContract: (data: Contract, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Contract;
        },
        ErrorResponse
      >({
        path: `/contract`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contract
     * @name UpdateContract
     * @request PUT:/contract
     * @secure
     */
    updateContract: (data: Contract, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Contract;
        },
        ErrorResponse
      >({
        path: `/contract`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contract
     * @name RemoveContract
     * @request DELETE:/contract
     * @secure
     */
    removeContract: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Contract;
        },
        ErrorResponse
      >({
        path: `/contract`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contract
     * @name SearchContract
     * @request GET:/contract/search
     * @secure
     */
    searchContract: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        name?: string;
        uniqIdentifier?: string;
        number?: string;
        handwritten?: boolean;
        badQualityPages?: boolean;
        documentType?: ("contract" | "agreement" | "order" | "offer")[];
        template?: string;
        responsible?: string;
        from?: string;
        to?: string;
        contractSubject?: string;
        contractSubjectSubCategory?: string;
        businessObject?: string;
        periodType?: (
          | "fixedTerm"
          | "IndefiniteTerm"
          | "untilCompletionWork"
          | "autoRenewal"
          | "trailPeriod"
        )[];
        period?: string;
        "period.from"?: string;
        "period.to"?: string;
        /** @format date-time */
        fromSigningDate?: string;
        /** @format date-time */
        toSigningDate?: string;
        paymentStatus?: ("unpaid" | "partiallyPayed" | "payed")[];
        invoiceStatus?: (
          | "draft"
          | "pendingApproval"
          | "notInvoiced"
          | "partiallyInvoiced"
          | "invoiced"
        )[];
        invoice?: string;
        company?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
        custom_boolean?: string;
        custom_number?: string;
        custom_float?: string;
        custom_string?: string;
        custom_date?: string;
        custom_geo_point?: string;
        custom_dense_vector?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Contract[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/contract/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contract
     * @name ContractFromPdf
     * @request POST:/contract/contractFromPdf
     * @secure
     */
    contractFromPdf: (
      data: {
        fileIds?: string[];
        originalFiles?: string;
        saveResultOnSuccess?: boolean;
        noDraft?: boolean;
        docType?: string;
        description?: string;
        contractId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            taskId?: string;
          };
        },
        ErrorResponse
      >({
        path: `/contract/contractFromPdf`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contract
     * @name IsContractUniq
     * @request POST:/contract/isContractUniq
     * @secure
     */
    isContractUniq: (
      data: {
        contract?: object;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            isUniq?: boolean;
          };
        },
        ErrorResponse
      >({
        path: `/contract/isContractUniq`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  contractNumber = {
    /**
     * No description
     *
     * @tags contractNumber
     * @name ReadContractNumber
     * @request GET:/contractNumber
     * @secure
     */
    readContractNumber: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ContractNumber;
        },
        ErrorResponse
      >({
        path: `/contractNumber`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contractNumber
     * @name CreateContractNumber
     * @request POST:/contractNumber
     * @secure
     */
    createContractNumber: (data: ContractNumber, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ContractNumber;
        },
        ErrorResponse
      >({
        path: `/contractNumber`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contractNumber
     * @name UpdateContractNumber
     * @request PUT:/contractNumber
     * @secure
     */
    updateContractNumber: (data: ContractNumber, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ContractNumber;
        },
        ErrorResponse
      >({
        path: `/contractNumber`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contractNumber
     * @name RemoveContractNumber
     * @request DELETE:/contractNumber
     * @secure
     */
    removeContractNumber: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ContractNumber;
        },
        ErrorResponse
      >({
        path: `/contractNumber`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contractNumber
     * @name SearchContractNumber
     * @request GET:/contractNumber/search
     * @secure
     */
    searchContractNumber: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ContractNumber[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/contractNumber/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  contractTemplate = {
    /**
     * No description
     *
     * @tags contractTemplate
     * @name ReadContractTemplate
     * @request GET:/contractTemplate
     * @secure
     */
    readContractTemplate: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ContractTemplate;
        },
        ErrorResponse
      >({
        path: `/contractTemplate`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contractTemplate
     * @name CreateContractTemplate
     * @request POST:/contractTemplate
     * @secure
     */
    createContractTemplate: (
      data: ContractTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ContractTemplate;
        },
        ErrorResponse
      >({
        path: `/contractTemplate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contractTemplate
     * @name UpdateContractTemplate
     * @request PUT:/contractTemplate
     * @secure
     */
    updateContractTemplate: (
      data: ContractTemplate,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ContractTemplate;
        },
        ErrorResponse
      >({
        path: `/contractTemplate`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contractTemplate
     * @name RemoveContractTemplate
     * @request DELETE:/contractTemplate
     * @secure
     */
    removeContractTemplate: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ContractTemplate;
        },
        ErrorResponse
      >({
        path: `/contractTemplate`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags contractTemplate
     * @name SearchContractTemplate
     * @request GET:/contractTemplate/search
     * @secure
     */
    searchContractTemplate: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        name?: string;
        documentType?: ("contract" | "agreement" | "order" | "offer")[];
        contractSubject?: string;
        contractSubjectSubCategory?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ContractTemplate[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/contractTemplate/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  country = {
    /**
     * No description
     *
     * @tags country
     * @name ReadCountry
     * @request GET:/country
     * @secure
     */
    readCountry: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Country;
        },
        ErrorResponse
      >({
        path: `/country`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags country
     * @name CreateCountry
     * @request POST:/country
     * @secure
     */
    createCountry: (data: Country, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Country;
        },
        ErrorResponse
      >({
        path: `/country`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags country
     * @name UpdateCountry
     * @request PUT:/country
     * @secure
     */
    updateCountry: (data: Country, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Country;
        },
        ErrorResponse
      >({
        path: `/country`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags country
     * @name RemoveCountry
     * @request DELETE:/country
     * @secure
     */
    removeCountry: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Country;
        },
        ErrorResponse
      >({
        path: `/country`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags country
     * @name SearchCountry
     * @request GET:/country/search
     * @secure
     */
    searchCountry: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        name?: string;
        native?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Country[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/country/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  deduplication = {
    /**
     * No description
     *
     * @tags deduplication
     * @name Deduplication
     * @request GET:/deduplication
     * @secure
     */
    deduplication: (
      query: {
        index: string;
        oldId: string;
        newId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            success?: boolean;
          };
        },
        ErrorResponse
      >({
        path: `/deduplication`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  draft = {
    /**
     * No description
     *
     * @tags draft
     * @name ReadDraft
     * @request GET:/draft
     * @secure
     */
    readDraft: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Draft;
        },
        ErrorResponse
      >({
        path: `/draft`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags draft
     * @name CreateDraft
     * @request POST:/draft
     * @secure
     */
    createDraft: (data: Draft, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Draft;
        },
        ErrorResponse
      >({
        path: `/draft`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags draft
     * @name UpdateDraft
     * @request PUT:/draft
     * @secure
     */
    updateDraft: (data: Draft, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Draft;
        },
        ErrorResponse
      >({
        path: `/draft`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags draft
     * @name RemoveDraft
     * @request DELETE:/draft
     * @secure
     */
    removeDraft: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Draft;
        },
        ErrorResponse
      >({
        path: `/draft`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags draft
     * @name SearchDraft
     * @request GET:/draft/search
     * @secure
     */
    searchDraft: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        name?: string;
        type?: (
          | "annex"
          | "contract"
          | "schedule"
          | "invoice"
          | "receipt"
          | "payment_order"
          | "bank_statement"
          | "debit_note"
          | "credit_note"
          | "construction_permit"
          | "property_deed"
          | "personal_identification"
          | "disability_certificate"
          | "business_license"
          | "tax_certificate"
          | "insurance_certificate"
          | "regulatory_approval"
          | "notice"
          | "termination_notice"
          | "termination_agreement"
          | "demand_letter"
          | "dispute_resolution_document"
          | "handover_protocol"
          | "maintenance_report"
          | "utility_bill"
          | "proforma_invoice"
          | "inventory_list"
          | "work_order"
          | "service_report"
          | "completion_certificate"
          | "inspection_report"
          | "progress_report"
          | "audit_report"
          | "guarantee_certificate"
          | "memorandum_of_understanding"
          | "letter_of_intent"
          | "non_disclosure_agreement"
          | "power_of_attorney"
          | "security_deposit_agreement"
          | "employment_agreement"
          | "invoice_protocol"
          | "invoice_description"
          | "original"
          | "other"
          | "property_handover_protocol"
          | "invoice_acceptance_protocol"
          | "work_completion_handover_protocol"
          | "settlement_agreement"
          | "blank_pages"
          | "mortgage_deed"
          | "cadastral_plan"
          | "payment_statement"
          | "approval_request"
          | "approval_acknowledgment"
        )[];
        user?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Draft[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/draft/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  exchangeRates = {
    /**
     * No description
     *
     * @tags exchangeRates
     * @name ReadExchangeRates
     * @request GET:/exchangeRates
     * @secure
     */
    readExchangeRates: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ExchangeRates;
        },
        ErrorResponse
      >({
        path: `/exchangeRates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags exchangeRates
     * @name CreateExchangeRates
     * @request POST:/exchangeRates
     * @secure
     */
    createExchangeRates: (data: ExchangeRates, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ExchangeRates;
        },
        ErrorResponse
      >({
        path: `/exchangeRates`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags exchangeRates
     * @name UpdateExchangeRates
     * @request PUT:/exchangeRates
     * @secure
     */
    updateExchangeRates: (data: ExchangeRates, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ExchangeRates;
        },
        ErrorResponse
      >({
        path: `/exchangeRates`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags exchangeRates
     * @name RemoveExchangeRates
     * @request DELETE:/exchangeRates
     * @secure
     */
    removeExchangeRates: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ExchangeRates;
        },
        ErrorResponse
      >({
        path: `/exchangeRates`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags exchangeRates
     * @name SearchExchangeRates
     * @request GET:/exchangeRates/search
     * @secure
     */
    searchExchangeRates: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        from?: ("eur" | "bgn")[];
        to?: ("eur" | "bgn")[];
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: ExchangeRates[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/exchangeRates/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  filesAndFolders = {
    /**
     * No description
     *
     * @tags filesAndFolders
     * @name ReadFilesAndFolders
     * @request GET:/filesAndFolders
     * @secure
     */
    readFilesAndFolders: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: FilesAndFolders;
        },
        ErrorResponse
      >({
        path: `/filesAndFolders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags filesAndFolders
     * @name CreateFilesAndFolders
     * @request POST:/filesAndFolders
     * @secure
     */
    createFilesAndFolders: (
      data: FilesAndFolders,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: FilesAndFolders;
        },
        ErrorResponse
      >({
        path: `/filesAndFolders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags filesAndFolders
     * @name UpdateFilesAndFolders
     * @request PUT:/filesAndFolders
     * @secure
     */
    updateFilesAndFolders: (
      data: FilesAndFolders,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: FilesAndFolders;
        },
        ErrorResponse
      >({
        path: `/filesAndFolders`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags filesAndFolders
     * @name RemoveFilesAndFolders
     * @request DELETE:/filesAndFolders
     * @secure
     */
    removeFilesAndFolders: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: FilesAndFolders;
        },
        ErrorResponse
      >({
        path: `/filesAndFolders`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags filesAndFolders
     * @name SearchFilesAndFolders
     * @request GET:/filesAndFolders/search
     * @secure
     */
    searchFilesAndFolders: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        groupId?: string;
        uniqIdentifier?: string;
        name?: string;
        link?: string;
        category?: (
          | "annex"
          | "contract"
          | "schedule"
          | "invoice"
          | "receipt"
          | "payment_order"
          | "bank_statement"
          | "debit_note"
          | "credit_note"
          | "construction_permit"
          | "property_deed"
          | "personal_identification"
          | "disability_certificate"
          | "business_license"
          | "tax_certificate"
          | "insurance_certificate"
          | "regulatory_approval"
          | "notice"
          | "termination_notice"
          | "termination_agreement"
          | "demand_letter"
          | "dispute_resolution_document"
          | "handover_protocol"
          | "maintenance_report"
          | "utility_bill"
          | "proforma_invoice"
          | "inventory_list"
          | "work_order"
          | "service_report"
          | "completion_certificate"
          | "inspection_report"
          | "progress_report"
          | "audit_report"
          | "guarantee_certificate"
          | "memorandum_of_understanding"
          | "letter_of_intent"
          | "non_disclosure_agreement"
          | "power_of_attorney"
          | "security_deposit_agreement"
          | "employment_agreement"
          | "invoice_protocol"
          | "invoice_description"
          | "original"
          | "other"
          | "property_handover_protocol"
          | "invoice_acceptance_protocol"
          | "work_completion_handover_protocol"
          | "settlement_agreement"
          | "blank_pages"
          | "mortgage_deed"
          | "cadastral_plan"
          | "payment_statement"
          | "approval_request"
          | "approval_acknowledgment"
        )[];
        shareWithClient?: boolean;
        type?: ("file" | "directory")[];
        systemType?: (
          | "communication"
          | "meeting"
          | "unknown"
          | "other"
          | "hidden"
          | "original"
        )[];
        parent?: string;
        representItem?: string;
        path?: string;
        user?: string;
        "user.id"?: string;
        party?: string;
        "party.id"?: string;
        mimetype?: string;
        fromFileSize?: number;
        toFileSize?: number;
        md5?: string;
        company?: string;
        contract?: string;
        relatedToItem?: string;
        notProcessed?: boolean;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: FilesAndFolders[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/filesAndFolders/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags filesAndFolders
     * @name ScanFilesAndFolders
     * @request POST:/filesAndFolders/scan
     * @secure
     */
    scanFilesAndFolders: (
      data: {
        files?: object[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            content?: string;
            file?: {
              path?: string;
              name?: string;
              size?: number;
            };
          };
        },
        ErrorResponse
      >({
        path: `/filesAndFolders/scan`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags filesAndFolders
     * @name FilesAndFoldersFromText
     * @request POST:/filesAndFolders/fileFromText
     * @secure
     */
    filesAndFoldersFromText: (
      data: {
        id?: string;
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            link?: string;
            mimetype?: string;
          };
        },
        ErrorResponse
      >({
        path: `/filesAndFolders/fileFromText`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags filesAndFolders
     * @name FilesAndFoldersTextract
     * @request POST:/filesAndFolders/textract
     * @secure
     */
    filesAndFoldersTextract: (
      data: {
        link?: string;
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            text?: string;
          };
        },
        ErrorResponse
      >({
        path: `/filesAndFolders/textract`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  gridCustomField = {
    /**
     * No description
     *
     * @tags gridCustomField
     * @name ReadGridCustomField
     * @request GET:/gridCustomField
     * @secure
     */
    readGridCustomField: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: GridCustomField;
        },
        ErrorResponse
      >({
        path: `/gridCustomField`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags gridCustomField
     * @name CreateGridCustomField
     * @request POST:/gridCustomField
     * @secure
     */
    createGridCustomField: (
      data: GridCustomField,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: GridCustomField;
        },
        ErrorResponse
      >({
        path: `/gridCustomField`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags gridCustomField
     * @name UpdateGridCustomField
     * @request PUT:/gridCustomField
     * @secure
     */
    updateGridCustomField: (
      data: GridCustomField,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: GridCustomField;
        },
        ErrorResponse
      >({
        path: `/gridCustomField`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags gridCustomField
     * @name RemoveGridCustomField
     * @request DELETE:/gridCustomField
     * @secure
     */
    removeGridCustomField: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: GridCustomField;
        },
        ErrorResponse
      >({
        path: `/gridCustomField`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags gridCustomField
     * @name SearchGridCustomField
     * @request GET:/gridCustomField/search
     * @secure
     */
    searchGridCustomField: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        name?: string;
        type?: (
          | "boolean"
          | "string"
          | "text"
          | "number"
          | "search"
          | "select"
          | "date"
          | "dateRange"
          | "currency"
          | "email"
          | "web"
          | "object"
          | "array"
        )[];
        index?: ("contract" | "party")[];
        description?: string;
        canSort?: boolean;
        canSearch?: boolean;
        company?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: GridCustomField[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/gridCustomField/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  jira = {
    /**
     * No description
     *
     * @tags jira
     * @name JiraWebhook
     * @request POST:/jira/webhook
     */
    jiraWebhook: (
      data: {
        To?: string;
        redirectUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            success?: boolean;
            taskId?: string;
          };
        },
        ErrorResponse
      >({
        path: `/jira/webhook`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags jira
     * @name JiraCallback
     * @request GET:/jira/jiraCallback
     */
    jiraCallback: (
      query: {
        code: string;
        state: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: any;
        },
        ErrorResponse
      >({
        path: `/jira/jiraCallback`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags jira
     * @name LoginJira
     * @request GET:/email/loginJira
     * @secure
     */
    loginJira: (
      query?: {
        jiraId?: string;
        jiraSecret?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            success?: boolean;
            redirectUrl?: string;
          };
        },
        ErrorResponse
      >({
        path: `/email/loginJira`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags jira
     * @name AutoContractProcessingJira
     * @request POST:/uploads/autoProcess
     * @secure
     */
    autoContractProcessingJira: (
      data: {
        files?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            success?: boolean;
            task_id?: string;
          };
        },
        ErrorResponse
      >({
        path: `/uploads/autoProcess`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags jira
     * @name CheckProgressJira
     * @request GET:/jira/checkProgress
     * @secure
     */
    checkProgressJira: (
      query: {
        issueId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: any;
        },
        ErrorResponse
      >({
        path: `/jira/checkProgress`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  log = {
    /**
     * No description
     *
     * @tags log
     * @name ReadLog
     * @request GET:/log
     * @secure
     */
    readLog: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Log;
        },
        ErrorResponse
      >({
        path: `/log`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags log
     * @name CreateLog
     * @request POST:/log
     * @secure
     */
    createLog: (data: Log, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Log;
        },
        ErrorResponse
      >({
        path: `/log`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags log
     * @name UpdateLog
     * @request PUT:/log
     * @secure
     */
    updateLog: (data: Log, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Log;
        },
        ErrorResponse
      >({
        path: `/log`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags log
     * @name RemoveLog
     * @request DELETE:/log
     * @secure
     */
    removeLog: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Log;
        },
        ErrorResponse
      >({
        path: `/log`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags log
     * @name SearchLog
     * @request GET:/log/search
     * @secure
     */
    searchLog: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        severity?: ("info" | "warn" | "error")[];
        type?: string;
        taskId?: string;
        name?: string;
        step?: string;
        environment?: ("server" | "jira")[];
        user?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Log[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/log/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  party = {
    /**
     * No description
     *
     * @tags party
     * @name ReadParty
     * @request GET:/party
     * @secure
     */
    readParty: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Party;
        },
        ErrorResponse
      >({
        path: `/party`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags party
     * @name CreateParty
     * @request POST:/party
     * @secure
     */
    createParty: (data: Party, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Party;
        },
        ErrorResponse
      >({
        path: `/party`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags party
     * @name UpdateParty
     * @request PUT:/party
     * @secure
     */
    updateParty: (data: Party, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Party;
        },
        ErrorResponse
      >({
        path: `/party`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags party
     * @name RemoveParty
     * @request DELETE:/party
     * @secure
     */
    removeParty: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Party;
        },
        ErrorResponse
      >({
        path: `/party`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags party
     * @name SearchParty
     * @request GET:/party/search
     * @secure
     */
    searchParty: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        type?: ("company" | "person")[];
        name?: string;
        email?: string;
        phone?: string;
        address?: string;
        oldParties?: string;
        company?: string;
        headmaster?: string;
        currency?: ("eur" | "bgn")[];
        uniqIdentifier?: string;
        countrySpecific?: string;
        "countrySpecific.bg.bulstat"?: string;
        "countrySpecific.bg.zdds"?: string;
        "countrySpecific.us.ledes"?: string;
        "countrySpecific.us.taxId"?: string;
        "countrySpecific.en.ledes"?: string;
        "countrySpecific.en.taxId"?: string;
        role?: string;
        own?: boolean;
        custom_boolean?: string;
        custom_number?: string;
        custom_float?: string;
        custom_string?: string;
        custom_date?: string;
        custom_geo_point?: string;
        custom_dense_vector?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Party[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/party/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags party
     * @name RegisterParty
     * @request POST:/party/register
     */
    registerParty: (data: Party, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            success?: boolean;
            token?: string;
            data?: Party;
          };
        },
        ErrorResponse
      >({
        path: `/party/register`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags party
     * @name LoginParty
     * @request POST:/party/login
     */
    loginParty: (
      data: {
        email?: string;
        password?: string;
        code?: string;
        publicUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            token?: string;
            taskId?: string;
            user?: Party;
          };
        },
        ErrorResponse
      >({
        path: `/party/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags party
     * @name LoginConfirmParty
     * @request POST:/party/loginConfirm
     */
    loginConfirmParty: (
      data: {
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            token?: string;
            code?: string;
            type?: string;
            user?: Party;
            error?: number;
            message?: string;
          };
        },
        ErrorResponse
      >({
        path: `/party/loginConfirm`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags party
     * @name LogoutParty
     * @request POST:/party/logout
     */
    logoutParty: (data: Party, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
        },
        ErrorResponse
      >({
        path: `/party/logout`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  qualityControlRule = {
    /**
     * No description
     *
     * @tags qualityControlRule
     * @name ReadQualityControlRule
     * @request GET:/qualityControlRule
     * @secure
     */
    readQualityControlRule: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: QualityControlRule;
        },
        ErrorResponse
      >({
        path: `/qualityControlRule`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags qualityControlRule
     * @name CreateQualityControlRule
     * @request POST:/qualityControlRule
     * @secure
     */
    createQualityControlRule: (
      data: QualityControlRule,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: QualityControlRule;
        },
        ErrorResponse
      >({
        path: `/qualityControlRule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags qualityControlRule
     * @name UpdateQualityControlRule
     * @request PUT:/qualityControlRule
     * @secure
     */
    updateQualityControlRule: (
      data: QualityControlRule,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: QualityControlRule;
        },
        ErrorResponse
      >({
        path: `/qualityControlRule`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags qualityControlRule
     * @name RemoveQualityControlRule
     * @request DELETE:/qualityControlRule
     * @secure
     */
    removeQualityControlRule: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: QualityControlRule;
        },
        ErrorResponse
      >({
        path: `/qualityControlRule`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags qualityControlRule
     * @name SearchQualityControlRule
     * @request GET:/qualityControlRule/search
     * @secure
     */
    searchQualityControlRule: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        name?: string;
        responsible?: string;
        contract?: string;
        businessObject?: string;
        contractObject?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: QualityControlRule[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/qualityControlRule/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  qualityControlScore = {
    /**
     * No description
     *
     * @tags qualityControlScore
     * @name ReadQualityControlScore
     * @request GET:/qualityControlScore
     * @secure
     */
    readQualityControlScore: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: QualityControlScore;
        },
        ErrorResponse
      >({
        path: `/qualityControlScore`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags qualityControlScore
     * @name CreateQualityControlScore
     * @request POST:/qualityControlScore
     * @secure
     */
    createQualityControlScore: (
      data: QualityControlScore,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: QualityControlScore;
        },
        ErrorResponse
      >({
        path: `/qualityControlScore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags qualityControlScore
     * @name UpdateQualityControlScore
     * @request PUT:/qualityControlScore
     * @secure
     */
    updateQualityControlScore: (
      data: QualityControlScore,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: QualityControlScore;
        },
        ErrorResponse
      >({
        path: `/qualityControlScore`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags qualityControlScore
     * @name RemoveQualityControlScore
     * @request DELETE:/qualityControlScore
     * @secure
     */
    removeQualityControlScore: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: QualityControlScore;
        },
        ErrorResponse
      >({
        path: `/qualityControlScore`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags qualityControlScore
     * @name SearchQualityControlScore
     * @request GET:/qualityControlScore/search
     * @secure
     */
    searchQualityControlScore: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        responsible?: string;
        contract?: string;
        businessObject?: string;
        contractObject?: string;
        qualityControlRule?: string;
        fromRating?: number;
        toRating?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: QualityControlScore[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/qualityControlScore/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  sync = {
    /**
     * No description
     *
     * @tags sync
     * @name ReadSync
     * @request GET:/sync
     * @secure
     */
    readSync: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Sync;
        },
        ErrorResponse
      >({
        path: `/sync`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sync
     * @name CreateSync
     * @request POST:/sync
     * @secure
     */
    createSync: (data: Sync, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Sync;
        },
        ErrorResponse
      >({
        path: `/sync`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sync
     * @name UpdateSync
     * @request PUT:/sync
     * @secure
     */
    updateSync: (data: Sync, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Sync;
        },
        ErrorResponse
      >({
        path: `/sync`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sync
     * @name RemoveSync
     * @request DELETE:/sync
     * @secure
     */
    removeSync: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Sync;
        },
        ErrorResponse
      >({
        path: `/sync`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags sync
     * @name SearchSync
     * @request GET:/sync/search
     * @secure
     */
    searchSync: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        user?: string;
        type?: (
          | "googleCalendar"
          | "microsoftCalendar"
          | "googleEmail"
          | "microsoftEmail"
          | "zoomMeeting"
          | "googleMeeting"
          | "microsoftMeeting"
          | "jira"
        )[];
        active?: boolean;
        syncs?: string;
        "syncs.source.id"?: string;
        "syncs.target.id"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Sync[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/sync/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  timeline = {
    /**
     * No description
     *
     * @tags timeline
     * @name ReadTimeline
     * @request GET:/timeline
     * @secure
     */
    readTimeline: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Timeline;
        },
        ErrorResponse
      >({
        path: `/timeline`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags timeline
     * @name CreateTimeline
     * @request POST:/timeline
     * @secure
     */
    createTimeline: (data: Timeline, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Timeline;
        },
        ErrorResponse
      >({
        path: `/timeline`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags timeline
     * @name UpdateTimeline
     * @request PUT:/timeline
     * @secure
     */
    updateTimeline: (data: Timeline, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Timeline;
        },
        ErrorResponse
      >({
        path: `/timeline`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags timeline
     * @name RemoveTimeline
     * @request DELETE:/timeline
     * @secure
     */
    removeTimeline: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Timeline;
        },
        ErrorResponse
      >({
        path: `/timeline`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags timeline
     * @name SearchTimeline
     * @request GET:/timeline/search
     * @secure
     */
    searchTimeline: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        file?: string;
        /** @format date-time */
        fromDate?: string;
        /** @format date-time */
        toDate?: string;
        contract?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Timeline[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/timeline/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  vatCountry = {
    /**
     * No description
     *
     * @tags vatCountry
     * @name ReadVatCountry
     * @request GET:/vatCountry
     * @secure
     */
    readVatCountry: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: VatCountry;
        },
        ErrorResponse
      >({
        path: `/vatCountry`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags vatCountry
     * @name CreateVatCountry
     * @request POST:/vatCountry
     * @secure
     */
    createVatCountry: (data: VatCountry, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: VatCountry;
        },
        ErrorResponse
      >({
        path: `/vatCountry`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags vatCountry
     * @name UpdateVatCountry
     * @request PUT:/vatCountry
     * @secure
     */
    updateVatCountry: (data: VatCountry, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: VatCountry;
        },
        ErrorResponse
      >({
        path: `/vatCountry`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags vatCountry
     * @name RemoveVatCountry
     * @request DELETE:/vatCountry
     * @secure
     */
    removeVatCountry: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: VatCountry;
        },
        ErrorResponse
      >({
        path: `/vatCountry`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags vatCountry
     * @name SearchVatCountry
     * @request GET:/vatCountry/search
     * @secure
     */
    searchVatCountry: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        country?: string;
        value?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: VatCountry[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/vatCountry/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  globalSearch = {
    /**
     * No description
     *
     * @tags globalSearch
     * @name GlobalSearch
     * @request GET:/globalSearch
     * @secure
     */
    globalSearch: (
      query: {
        searchTerm: string;
        allowIndices?: string[];
        excludeFromSearch?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: any[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/globalSearch`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  invoice = {
    /**
     * No description
     *
     * @tags invoice
     * @name ReadInvoice
     * @request GET:/invoice
     * @secure
     */
    readInvoice: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Invoice;
        },
        ErrorResponse
      >({
        path: `/invoice`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice
     * @name CreateInvoice
     * @request POST:/invoice
     * @secure
     */
    createInvoice: (data: Invoice, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Invoice;
        },
        ErrorResponse
      >({
        path: `/invoice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice
     * @name UpdateInvoice
     * @request PUT:/invoice
     * @secure
     */
    updateInvoice: (data: Invoice, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Invoice;
        },
        ErrorResponse
      >({
        path: `/invoice`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice
     * @name RemoveInvoice
     * @request DELETE:/invoice
     * @secure
     */
    removeInvoice: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Invoice;
        },
        ErrorResponse
      >({
        path: `/invoice`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice
     * @name SearchInvoice
     * @request GET:/invoice/search
     * @secure
     */
    searchInvoice: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        type?: (
          | "invoice"
          | "advancePayment"
          | "creditNote"
          | "debitNote"
          | "reversalProtocol"
        )[];
        number?: string;
        noteType?: ("value" | "quantity")[];
        status?: (
          | "draft"
          | "pendingApproval"
          | "unpaid"
          | "partiallyPayed"
          | "canceled"
          | "reversal"
          | "payed"
        )[];
        period?: string;
        "period.from"?: string;
        "period.to"?: string;
        /** @format date-time */
        fromOverdueDate?: string;
        /** @format date-time */
        toOverdueDate?: string;
        fromCompany?: string;
        toCompany?: string;
        items?: string;
        "items.subject.id"?: string;
        "items.contract.id"?: string;
        "items.businessObject.id"?: string;
        deliveryStatus?: ("notSent" | "sent" | "delivered")[];
        related?: string;
        forApproveDescription?: string;
        /** @format date-time */
        fromDateForApprove?: string;
        /** @format date-time */
        toDateForApprove?: string;
        /** @format date-time */
        fromDateApprove?: string;
        /** @format date-time */
        toDateApprove?: string;
        user?: string;
        sendForApprove?: string;
        approvedFor?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        file?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: Invoice[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/invoice/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice
     * @name SendInvoice
     * @request GET:/invoice/send
     * @secure
     */
    sendInvoice: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: {
            success?: boolean;
            taskId?: string;
          };
        },
        ErrorResponse
      >({
        path: `/invoice/send`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoice
     * @name ExternalDownloadInvoice
     * @request GET:/invoice/externalDownload
     */
    externalDownloadInvoice: (
      query: {
        link: string;
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<File, ErrorResponse>({
        path: `/invoice/externalDownload`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  invoiceNumber = {
    /**
     * No description
     *
     * @tags invoiceNumber
     * @name ReadInvoiceNumber
     * @request GET:/invoiceNumber
     * @secure
     */
    readInvoiceNumber: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceNumber;
        },
        ErrorResponse
      >({
        path: `/invoiceNumber`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceNumber
     * @name CreateInvoiceNumber
     * @request POST:/invoiceNumber
     * @secure
     */
    createInvoiceNumber: (data: InvoiceNumber, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceNumber;
        },
        ErrorResponse
      >({
        path: `/invoiceNumber`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceNumber
     * @name UpdateInvoiceNumber
     * @request PUT:/invoiceNumber
     * @secure
     */
    updateInvoiceNumber: (data: InvoiceNumber, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceNumber;
        },
        ErrorResponse
      >({
        path: `/invoiceNumber`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceNumber
     * @name RemoveInvoiceNumber
     * @request DELETE:/invoiceNumber
     * @secure
     */
    removeInvoiceNumber: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceNumber;
        },
        ErrorResponse
      >({
        path: `/invoiceNumber`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceNumber
     * @name SearchInvoiceNumber
     * @request GET:/invoiceNumber/search
     * @secure
     */
    searchInvoiceNumber: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        /** @format date-time */
        fromDate_created?: string;
        /** @format date-time */
        toDate_created?: string;
        /** @format date-time */
        fromDate_updated?: string;
        /** @format date-time */
        toDate_updated?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceNumber[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/invoiceNumber/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  invoiceProtocol = {
    /**
     * No description
     *
     * @tags invoiceProtocol
     * @name ReadInvoiceProtocol
     * @request GET:/invoiceProtocol
     * @secure
     */
    readInvoiceProtocol: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceProtocol;
        },
        ErrorResponse
      >({
        path: `/invoiceProtocol`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceProtocol
     * @name CreateInvoiceProtocol
     * @request POST:/invoiceProtocol
     * @secure
     */
    createInvoiceProtocol: (
      data: InvoiceProtocol,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceProtocol;
        },
        ErrorResponse
      >({
        path: `/invoiceProtocol`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceProtocol
     * @name UpdateInvoiceProtocol
     * @request PUT:/invoiceProtocol
     * @secure
     */
    updateInvoiceProtocol: (
      data: InvoiceProtocol,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceProtocol;
        },
        ErrorResponse
      >({
        path: `/invoiceProtocol`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceProtocol
     * @name RemoveInvoiceProtocol
     * @request DELETE:/invoiceProtocol
     * @secure
     */
    removeInvoiceProtocol: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceProtocol;
        },
        ErrorResponse
      >({
        path: `/invoiceProtocol`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceProtocol
     * @name SearchInvoiceProtocol
     * @request GET:/invoiceProtocol/search
     * @secure
     */
    searchInvoiceProtocol: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        number?: string;
        fromCompany?: string;
        toCompany?: string;
        related?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceProtocol[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/invoiceProtocol/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  invoiceRule = {
    /**
     * No description
     *
     * @tags invoiceRule
     * @name ReadInvoiceRule
     * @request GET:/invoiceRule
     * @secure
     */
    readInvoiceRule: (
      query: {
        id: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceRule;
        },
        ErrorResponse
      >({
        path: `/invoiceRule`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceRule
     * @name CreateInvoiceRule
     * @request POST:/invoiceRule
     * @secure
     */
    createInvoiceRule: (data: InvoiceRule, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceRule;
        },
        ErrorResponse
      >({
        path: `/invoiceRule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceRule
     * @name UpdateInvoiceRule
     * @request PUT:/invoiceRule
     * @secure
     */
    updateInvoiceRule: (data: InvoiceRule, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceRule;
        },
        ErrorResponse
      >({
        path: `/invoiceRule`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceRule
     * @name RemoveInvoiceRule
     * @request DELETE:/invoiceRule
     * @secure
     */
    removeInvoiceRule: (
      query: {
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceRule;
        },
        ErrorResponse
      >({
        path: `/invoiceRule`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags invoiceRule
     * @name SearchInvoiceRule
     * @request GET:/invoiceRule/search
     * @secure
     */
    searchInvoiceRule: (
      query?: {
        page?: number;
        size?: number;
        countOnly?: boolean;
        sort?: string;
        agg?: string[];
        lang?: string;
        searchTerm?: string;
        searchType?: "text" | "vector" | "ai";
        id?: string;
        tid?: string;
        invoicePeriod?: ("month" | "halfMonth" | "everyAction")[];
        paymentMethod?: ("bank" | "cash")[];
        invoiceGenerationMethod?: ("auto" | "manual")[];
        fromCreditTerm?: number;
        toCreditTerm?: number;
        fromCompany?: string;
        toCompany?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success?: boolean;
          version?: string;
          data?: InvoiceRule[];
          count?: number;
          aggregations?: object;
        },
        ErrorResponse
      >({
        path: `/invoiceRule/search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
